import { getCustomTag, useNavigation, useRouteParams, useTranslation } from '@msdk/common'
import { CustomActionButtonAspect, DefaultActionType, Entity, OpenMode } from '@msdk/definitions'
import React from 'react'

import { useFormModal } from '../../../hooks'
import { ActionVisualizationMode } from '../../FormActions/action-visualization'
import { ActionElement } from '../../FormActions/ActionElement'
import { useDynamicViewContext } from '../context'
import { ActionLabels, getEditActionLabels } from './labels-utils'

interface Props {
  row: Entity
  visualizationMode: ActionVisualizationMode
  onClose?: () => void
}

export function EditRowAction({ row, visualizationMode, onClose }: Props) {
  const { reload, modalRef, viewModel, entityModel, isEmbedded, onDataChanged } = useDynamicViewContext()
  const { itemId } = useRouteParams()

  const actionDetails = entityModel.defaultActionsDetails.find((e) => e.type === DefaultActionType.Edit)

  const navigate = useNavigation()
  const t = useTranslation()
  const { createModal } = useFormModal()

  const labels: ActionLabels = getEditActionLabels(actionDetails, t)

  const onRowClicked = () => {
    onClose && onClose()

    const form = entityModel.editForm ?? entityModel.defaultForm
    if (!modalRef && !isEmbedded && viewModel.openMode !== OpenMode.Modal) {
      const ctx: Record<string, string> = { [row.entityName]: row.id }
      const qs = new URLSearchParams()
      qs.append('mode', 'Edit')

      if (itemId) {
        // Add the current sitemap item id to the context so that
        // when we go back from the form we can find the correct item
        // to go back to
        ctx['sId'] = itemId
      }

      navigate(`${row.entityName}/${form}/${row.id}`, viewModel.associatedSiteMap, ctx, qs)
    } else {
      const modal = createModal(
        row.entityName,
        form,
        row.id,
        (entity: Entity) => {
          if (entity) {
            reload()
            onDataChanged && onDataChanged()
          }
        },
        {
          modalForm: viewModel.modalForm,
        },
      )
      modal.open()
    }
  }

  return (
    <ActionElement
      icon={labels.iconTag}
      label={labels.description}
      onClick={onRowClicked}
      visualizationMode={visualizationMode}
      disabled={false}
      aspect={CustomActionButtonAspect.Primary}
      testId={getCustomTag(['FORM', 'EDIT', 'button'])}
    />
  )
}
